import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BasicButtonColors, BasicButtonModes, BasicButtonSizes } from '@app/shared/enums/buttons';
import { DialogData } from '@app/shared/interfaces/dialog.interface';

@Component({
  selector: 'cm-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  public data = inject(MAT_DIALOG_DATA) as DialogData;

  BasicButtonColors = BasicButtonColors;
  BasicButtonModes = BasicButtonModes;
  BasicButtonSizes = BasicButtonSizes;
  defaultWidth = 600;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  clickAction(action: string) {
    this.dialogRef.close(action);
  }
}
